export enum IstatCustomerMode {
  IstatCustomerModeIn = 'ISTAT_CUSTOMER_MODE_IN',
  IstatCustomerModeOut = 'ISTAT_CUSTOMER_MODE_OUT',
  IstatCustomerModeStill = 'ISTAT_CUSTOMER_MODE_STILL',
  IstatCustomerModeTax = 'ISTAT_CUSTOMER_MODE_TAX',
}
